var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PersonService from "../../services/PersonService";
import { debouncePromise } from "../../util/debounce";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
/**
 * DEPRECATED. Please use the lookup defined in the 'personLookupNew.jsx' file instead. The main differences are that
 * this control only allows selection of a single person, while the personLookupNew.jsx component allows multiple; and
 * this component uses the person's affiliation ID to identify the selected person and set values, while the personLookupNew.jsx
 * component uses the person's Person ID for this purpose.
 *
 * @param {*} props - The props.
 */
const PersonLookup = (_a) => {
    var { onPersonSelected, selectedPerson } = _a, others = __rest(_a, ["onPersonSelected", "selectedPerson"]);
    function handleChange(person) {
        if (onPersonSelected) {
            onPersonSelected(person);
        }
    }
    function renderPersonOption(person) {
        return (_jsxs("span", { children: [person.fullName, " ", _jsxs("small", { children: ["(", person.studentId, ")"] })] }));
    }
    function searchUsers(input) {
        return PersonService.listAsJson(input)
            .then((people) => ({ options: people }))
            .catch(() => {
            return { options: [] };
        });
    }
    return (_jsx(DeprecatedSelect.Async, Object.assign({}, others, { loadOptions: debouncePromise(searchUsers, 300), name: "form-field-name", onChange: handleChange, getOptionLabel: renderPersonOption, value: selectedPerson, valueKey: "affiliationId" })));
};
export default PersonLookup;
